// removed by extract-text-webpack-plugin
module.exports = {"uso":"_17j9zGavC4ceWbYDYLW55l","left":"_1LxKB9qJp5o68RcQU-ewq7","right":"_2ozAu4_B2YT5i1odWLF9Pz","caption":"_1PIZLCuBnxHLQ2toHEZqL7","wrap":"_2y3jFXXtvYt_x1jJqFBBPE","triangle-left":"_1EGuwnVNs0gkJIoonGgcY9","triangle-right":"_3jNcRdfJYY3jr2CVAXhNRk","avar":"LVGL3-r59lBA3iOPju5Hy","blink":"_3UFQfZZb8GVPgoJcGfL0tj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/entries/Uso/style.css
// module id = 343
// module chunks = 0